import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'src/utils/axiosCatalog';
import axiosHeadOffice from 'src/utils/axiosWOBaseUrl';

export const getExchangeReasonCatalog = createAsyncThunk('/GetExchangeReasonCatalog', async () => {
  const response = await axios.get('/GetExchangeReasonCatalog');
  return response.data;
});

export const getExchangeReasonDetail = createAsyncThunk(
  '/getExchangeReasonDetailCatalog',
  async (id) => {
    const response = await axios.get(`/GetChangeReasonDetailCatalog/${id}`);
    return response.data;
  }
);

export const getExchangeReasonDetails = createAsyncThunk(
  '/getExchangeReasonDetailCatalog',
  async () => {
    const response = await axios.get(`/GetChangeReasonDetailsCatalog`);
    return response.data;
  }
);

export const EditExchangeReasonDetail = createAsyncThunk(
  '/editExchangeReasonDetailCatalog',
  async (data) => {
    const response = await axios.post(`/EditExchangeReasonDetail`,data);
    return response.data;
  }
);

export const CreateExchangeReasonDetail = createAsyncThunk(
  '/CreateExchangeReasonDetail',
  async (data) => {
    const response = await axios.post(`/CreateExchangeReasonDetail`,data);
    return response.data;
  }
);

export const getLanguageList = createAsyncThunk(
  '/getLanguageList',
  async () => {
    const response = await axiosHeadOffice.get('/Technician/GetLanguageList');
    return response.data;
  }
);

const exchangeReasonDetailsSlice = createSlice({
  name: 'exchangeReasonDetails',
  initialState: {
    selectedItemId: 0,
    selectedItemText:'',
    selectedItemReason:'',
    selectecItemResonId:0,
    operationType :0,
    loading: false,
    error: '',
    exchangeReasonTypes: [],
    exchangeReasonDetails: [],
    response: ''
  },
  reducers: {
    changeSelectedAppTranslationId(state, action) {
      state.SelectedAppTranslationId = action.payload;
      state.loading = false; 
    },
    setSelectedItem(state, action) {
      state.selectedItemId = action.payload.ItemId;
      state.selectedItemText = action.payload.ItemText;
      state.selectedItemReason = action.payload.Reason;
      state.selectecItemResonId = action.payload.ReasonId;
      state.operationType = action.payload.operationType
    },
    changeReason(state,action){
      var reason = state.exchangeReasonTypes.find(r=>r.YourLanguageDescription == action.payload);
      state.selectedItemReason = action.payload;
      state.selectecItemResonId = reason.Id;
    },
    ClearData(state) {
      state.selectedItemId = 0;
      state.selectedItemText = '';
      state.selectedItemReason = '';
      state.selectecItemResonId = 0;
      state.operationType = 0;
      state.error= '';
      state.response= '';
    },
    setSelectedItemText(state,action) {
      state.selectedItemText = action.payload;
    },
    resetDescriptions(state) {
      state.exchangeReasonDescriptions = [];
      state.loading = false;
    }
  },
  extraReducers: {
    [getExchangeReasonCatalog.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeReasonCatalog.rejected]: (state, action) => {
      state.loading = false;
    },
    [getExchangeReasonCatalog.fulfilled]: (state, action) => {
      state.exchangeReasonTypes = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetail.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeReasonDetail.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetail.fulfilled]: (state, action) => {
      state.exchangeReasonDescriptions = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetails.pending]: (state) => {
      state.loading = true;
    },
    [getExchangeReasonDetails.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getExchangeReasonDetails.fulfilled]: (state, action) => {
      state.exchangeReasonDetails = action.payload;
      state.loading = false;
    },
    [getLanguageList.pending]: (state) => {
      state.loading = true;
    },
    [getLanguageList.rejected]: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    [getLanguageList.fulfilled]: (state, action) => {
      state.exchangeReasonDescriptions = action.payload;
      state.loading = false;
    }    
  }
});

export const exchangeReasonDetailsActions = exchangeReasonDetailsSlice.actions;

export default exchangeReasonDetailsSlice;
